(function ($, window, document) {
  "use strict";

  if (!$) {
    console.error("jQuery not found. Aborting script.");
    return;
  }

  $(function () {
    try {
      /* ---------- Helpers ---------- */
      const hasEl = (sel) => document.querySelector(sel) !== null;

      const safeTextNum = (sel, fallback = 1) => {
        const el = document.querySelector(sel);
        if (!el) return fallback;
        const n = Number(String(el.textContent || el.innerText || "").trim());
        return Number.isFinite(n) && n > 0 ? n : fallback;
      };

      const setText = (sel, val) => {
        const el = document.querySelector(sel);
        if (el) el.textContent = String(val);
      };

      const setAttr = (el, name, val) => {
        if (el && el.setAttribute) el.setAttribute(name, val);
      };

      const getAttr = (el, name) =>
        el && el.getAttribute ? el.getAttribute(name) : null;

      const escapeAttrValue = (value) =>
        window.CSS && CSS.escape
          ? CSS.escape(value)
          : String(value).replace(/"/g, '\\"');

      const safeInitSwiper = (selector, options) => {
        if (typeof window.Swiper !== "function") {
          // If Swiper is not available, just skip without throwing.
          return null;
        }
        if (!hasEl(selector)) return null;
        try {
          return new window.Swiper(selector, options);
        } catch (e) {
          console.error("Swiper init failed for", selector, e);
          return null;
        }
      };

      // Ensure images are lazy-loaded if not set
      $("img").each(function () {
        if (!this.hasAttribute("loading")) this.setAttribute("loading", "lazy");
      });

      /* ---------- Swipers ---------- */
      const swiperProduct = safeInitSwiper(".mp_product-carousel", {
        slidesPerView: 4,
        spaceBetween: 24,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          1024: { slidesPerView: 4 },
          768: { slidesPerView: 2 },
          480: { slidesPerView: 1 },
        },
      });

      const thumbSwiper = safeInitSwiper(".product__primary-carousel-thumbs", {
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

      const mainSwiper = safeInitSwiper(".product__primary-carousel", {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: thumbSwiper ? { swiper: thumbSwiper } : undefined,
      });

      safeInitSwiper(".mp-reviews_carousel", {
        loop: true,
        spaceBetween: 8,
        slidesPerView: 3,
        navigation: {
          nextEl: ".mp_swiper-button-next",
          prevEl: ".mp_swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });

      safeInitSwiper(".mp_reviews_carousel-main", {
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next_rev",
          prevEl: ".swiper-button-prev_rev",
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
            slidesPerView: 2,
            centeredSlides: false,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
          1024: {
            slidesPerView: 4,
            centeredSlides: false,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      });

      /* ---------- Events ---------- */

      // Reviews video blocks – use delegated handler for dynamic content
      $(document).on("click", ".mp-reviews_carousel_block", function () {
        const $clickedBlock = $(this);
        const $clickedVideo = $clickedBlock.find("video").get(0);
        const $clickedMuteIcon = $clickedBlock.find(".mp_review_mute");
        const $clickedUnmuteIcon = $clickedBlock.find(".mp_review_unmute");

        if (!$clickedVideo) return;

        // Mute all other videos and reset their icons
        $(".mp-reviews_carousel_block").each(function () {
          const $block = $(this);
          const v = $block.find("video").get(0);
          if (!v || v === $clickedVideo) return;
          v.muted = true;
          $block.find(".mp_review_mute").show();
          $block.find(".mp_review_unmute").hide();
        });

        // Restart clicked video
        try {
          $clickedVideo.currentTime = 0;
        } catch (e) {}
        $(".mp-review_play-btn").css("display", "flex");

        // Toggle mute state of clicked video
        if ($clickedVideo.muted) {
          $clickedVideo.muted = false;
          $clickedMuteIcon.hide();
          $clickedUnmuteIcon.show();
          $clickedBlock.find(".mp-review_play-btn").hide();
        } else {
          $clickedVideo.muted = true;
          $clickedMuteIcon.show();
          $clickedUnmuteIcon.hide();
        }

        // Ensure playback
        if (typeof $clickedVideo.play === "function") {
          $clickedVideo.play().catch(() => {
            /* ignore autoplay errors */
          });
        }
      });

      // Accordion
      $(document).on("click", ".main-product__accordion", function () {
        $(this).toggleClass("active");
        $(this).find(".main-product__accord-content").slideToggle();
      });

      // Variant selection
      $(document).on("click", ".product-variants-config__data", function () {
        const $opt = $(this).closest(".product-form_option");
        $opt.find(".product-variants-config__data").removeClass("active");
        $(this).addClass("active");
        getVariant();

        const $colorActive = $(".product-form__value_color.active");
        if (mainSwiper && typeof mainSwiper.slideTo === "function") {
          mainSwiper.slideTo(0);
        }

        const selectedTitle = $(this).find("p").html();
        if (selectedTitle) {
          $opt.find(".product-form_label_selected__js").html(selectedTitle);
        }
      });

      // Qty minus
      $(document).on("click", ".product-form_qty_adjust.minus", function () {
        let currentQty = safeTextNum(".product-form_qty_value", 1);
        if (currentQty > 1) currentQty--;
        setText(".product-form_qty_value", currentQty);
        const mainQty = document.querySelector(".product-form_main_qty");
        setAttr(mainQty, "value", currentQty);
      });

      // Qty plus
      $(document).on("click", ".product-form_qty_adjust.plus", function () {
        let currentQty = safeTextNum(".product-form_qty_value", 1);
        currentQty++;
        setText(".product-form_qty_value", currentQty);
        const mainQty = document.querySelector(".product-form_main_qty");
        setAttr(mainQty, "value", currentQty);
      });

      // Primary button – safe redirect/scroll
      $(document).on("click", ".mp_btn-primary", function (evt) {
        evt.preventDefault();
        const href = $(this).attr("href");
        if (href && href !== "#") {
          window.location.href = href;
        } else if (hasEl(".product_main_container")) {
          $("html, body").animate(
            {
              scrollTop: $(".product_main_container").offset().top,
            },
            500
          );
        }
      });

      // Quick add toggle
      $(document).on("click", ".product-form_up_atc", function () {
        const currentId = $(this).attr("data-id");
        if (!currentId) return;
        $(
          `.collection-grid-card__quickadd[data-id="${escapeAttrValue(currentId)}"]`
        ).css("display", "flex");
      });

      /* ---------- Functions ---------- */
      function getVariant() {
        const activeOptions = $(".product-variants-config__data.active");
        if (!activeOptions.length) return;

        const parts = [];
        activeOptions.each(function () {
          const v = $(this).attr("data");
          if (v) parts.push(v);
        });
        const fullTitle = parts.join("-");
        if (!fullTitle) return;

        const selector = `.product-variant__data[data-title="${escapeAttrValue(fullTitle)}"]`;
        const $variant = $(selector).first();
        if (!$variant.length) {
          console.warn("Variant not found for", fullTitle);
          return;
        }

        const currentId = $variant.attr("data-id");
        const currentImg = $variant.attr("data-src");

        const mainImgWrap = document.querySelector(
          ".product__primary-main-img__js img"
        );
        if (mainImgWrap && currentImg) mainImgWrap.src = currentImg;

        const idInput = document.querySelector(".product-form_main_id");
        if (idInput && currentId) setAttr(idInput, "value", currentId);
      }

      function preselectImages() {
        const t2 = $(".ppConfig_2 .active").attr("data") || "";
        const t3 = $(".ppConfig_3 .active").attr("data") || "";

        $(".product-form__value_color").each(function () {
          const t1 = $(this).attr("data") || "";
          const fullTitle = [t1, t2, t3].filter(Boolean).join("-");
          if (!fullTitle) return;

          const selector = `.product-variant__data[data-title="${escapeAttrValue(fullTitle)}"]`;
          const $variant = $(selector).first();
          const currentImg = $variant.attr("data-src");

          const img = $(this).find("img").get(0);
          if (img && currentImg) img.src = currentImg;
        });
      }

      // Initialize safely
      preselectImages();
      getVariant();

      /* ---------- Delivery date ---------- */
      function getBusinessDayFromToday(offsetDays) {
        let date = new Date();
        let added = 0;
        while (added < (Number(offsetDays) || 0)) {
          date.setDate(date.getDate() + 1);
          const day = date.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return date;
      }

      function formatDate(date) {
        try {
          const options = { weekday: "long", day: "numeric", month: "long" };
          return date.toLocaleDateString(undefined, options);
        } catch (e) {
          // Fallback: YYYY-MM-DD
          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, "0");
          const dd = String(date.getDate()).padStart(2, "0");
          return `${yyyy}-${mm}-${dd}`;
        }
      }

      const targetDate = getBusinessDayFromToday(3);
      const formattedDate = formatDate(targetDate);
      setText(".cher_pp_delivery__Date", formattedDate);
    } catch (err) {
      console.error("Unexpected error in ready handler:", err);
    }
  });
})(window.jQuery, window, document);
